<template>
  <router-view v-if="$route.name!='activity-activity'" />
  <el-card v-else>
    <div slot="header">
      <h1 class="has-operation">
        <div>
          <div>内购活动列表</div>
          <div class="addres-tip">内购活动统一登录地址：{{`${this.$config.client.web.baseUrl}`}}</div>
        </div>
        <el-button-group>
          <router-link :to="{ name: 'activity-activity-create'}" target="_blank">
            <el-button type="primary" icon="el-icon-plus">创建内购活动</el-button>
          </router-link>
        </el-button-group>
      </h1>
    </div>
    <el-form inline :model="query" class="filter-form">
      <el-form-item label="活动名称">
        <el-input v-model.trim="query.activityName" placeholder="活动名称" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable placeholder="请选择">
          <el-option v-for="item in $enums.activityStatus.getList()" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="downLoadTemplate">
          限购规则导入模板下载
        </el-button>

      </el-form-item>
    </el-form>

    <el-table class="table block" v-loading="loading" :data="collection">
      <el-table-column prop="id" label="活动ID" width="100px" />
      <el-table-column prop="activityName" label="活动名称" />
      <el-table-column label="关联公司">
        <div slot-scope="scope" class="flex flex-col">
          <div style="margin-bottom:5px" v-for="(item, index) in scope.row.companies" :key="index">
            {{ item.company.emailSuffix ? `${item.company.name}(${item.company.emailSuffix})` : item.company.name }}</div>
        </div>
      </el-table-column>
      <el-table-column label="活动状态" :formatter="formatStatus" width="120px" />
      <el-table-column prop="updatedAt" label="更新时间" :formatter="$tableHelper.fmts.date" width="150px" />
      <el-table-column align="center" label="操作" width="150px">
        <template slot-scope="scope">
          <router-link :to="{ name: 'activity-activity-edit', params: { id: scope.row.id }}" target="_blank">
            <el-button type="text">编辑</el-button>
          </router-link>
          <Divider type="vertical" />
          <el-dropdown>
            <span class="dropdown-link">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <router-link :to="{ name: 'activity-activity-product', params: { id: scope.row.id }}">
                <el-dropdown-item>商品清单</el-dropdown-item>
              </router-link>
              <!-- <el-dropdown-item>
                <span style="display: block" @click="openCopyActivityLink(scope.row)">获取活动地址</span>
              </el-dropdown-item> -->
              <el-dropdown-item>
                <span style="display: block" @click="goPageSetting(scope.row)">页面设置</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span style="display: block" @click="exportActivityProduct(scope.row)">库存导出</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <uploader target="activity-custom-rules" :params="{activityId: scope.row.id}" @success="handleImportSuccess" @error="handleImportError" accept=".xlsx,.xls,.csv">
                  导入限购规则
                </uploader>
              </el-dropdown-item>
              <el-dropdown-item>
                <span style="display: block" @click="exportActivityRule(scope.row.id)">导出限购规则</span>
              </el-dropdown-item>
              <router-link :to="{ name: 'activity-activity-discount', params: { id: scope.row.id, activityName: scope.row.activityName }}">
                <el-dropdown-item>折扣设置</el-dropdown-item>
              </router-link>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <copy-activity-link :visible="this.activityLink !== ''" :activityLink=this.activityLink :title="activityLinkName" @close="closeCopyActivityLink" />
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
import Divider from '../../components/Divider/index'
import CopyActivityLink from "./copyActivityLink"
import store from '@/store'
const FileDownload = require('js-file-download')
const { mapGetters } = createNamespacedHelpers('activities')

export default {
  data() {
    return {
      loading: false,
      activityLink: '',
      activityLinkName: '',
      query: {
        status: '',
        activityName: '',
      }
    }
  },
  components: {
    CopyActivityLink,
    Divider
  },
  computed: {
    ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
  },
  methods: {
    openCopyActivityLink(activity) {
      this.activityLink = `${this.$config.client.web.baseUrl}/land/${activity.id}`
      this.activityLinkName = activity.activityName
    },

    closeCopyActivityLink() {
      this.activityLink = ''
    },

    goPageSetting(activity) {
      this.$router.push({ name: 'activity-activity-pagesetting-home-show', query: { activityId: activity.id } })
    },

    formatStatus(activity) {
      const statusEnums = this.$enums.activityStatus
      const now = moment()
      const dateFrom = moment(activity.dateFrom)
      const dateTo = moment(activity.dateTo)

      let status = ''
      if (now.isAfter(dateTo)) {
        status = statusEnums.COMPLETE
      } else if (now.isBefore(dateFrom)) {
        status = statusEnums.PENDING
      } else {
        status = statusEnums.ONGOING
      }
      return this.$enums.activityStatus.label(status)
    },
    async queryCollection({ pagination = { limit: 10 } } = {}) {
      let query = {
        ...this.query,
        activityName: this.query.activityName ? `%${this.query.activityName}%` : undefined // 设为模糊搜索
      }

      this.parseStatusQuery(query)

      try {
        this.loading = true
        await this.$store.dispatch('activities/collection', { query, pagination })
      } finally {
        this.loading = false
      }
    },
    parseStatusQuery(query) {
      const statusEnums = this.$enums.activityStatus
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      switch (query.status) {
        case statusEnums.PENDING:
          query.dateFrom = `>${now}`
          break
        case statusEnums.ONGOING:
          query.dateFrom = `<=${now}`
          query.dateTo = `>=${now}`
          break
        case statusEnums.COMPLETE:
          query.dateTo = `<${now}`
          break
      }

      delete query.status
    },
    async exportActivityProduct(activity) {
      const query = {
        "activityId": activity.id
      }
      try {
        const data = await this.$store.dispatch('report/activityProductReport', query)
        FileDownload(data, 'activity_product_report [' + activity.activityName + '].xlsx')
      } finally {
        this.loading = false
      }
      this.$message.success('活动商品库存导出成功')
    },
    exportActivityRule(activityId) {
      const { token } = store.state.auth
      const baseUrl = this.$config.api.baseURL
      window.open(`${baseUrl}/activity-custom-rules?activityId=${activityId}&token=${token}`)
    },
    downLoadTemplate() {
      const { token } = store.state.auth
      const baseUrl = this.$config.api.baseURL
      window.open(`${baseUrl}/activity-custom-rules?activityId=-1&token=${token}`)
    },
    handleImportSuccess(res) {
      this.exportData = res
      if (res.err.length > 0) {
        this.successModal = true
      } else {
        this.$message.success(`导入成功`)
      }
      this.queryCollection()
    },
    handleImportError(error) {
      this.$message.error('导入失败了：' + error.message)
    }
  },
  mounted() {
    this.queryCollection()
  },
  activated() {
    this.queryCollection()
  }
}
</script>

<style lang="less" scoped>
.addres-tip {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}
</style>